/**
 *  Copyright [2022] [https://www.xiaonuo.vip]
 *	Snowy采用APACHE LICENSE 2.0开源协议，您在使用过程中，需要注意以下几点：
 *	1.请不要删除和修改根目录下的LICENSE文件。
 *	2.请不要删除和修改Snowy源码头部的版权声明。
 *	3.本项目代码可免费商业使用，商业使用请保留源码和相关描述文件的项目出处，作者声明等。
 *	4.分发源码时候，请注明软件出处 https://www.xiaonuo.vip
 *	5.不可二次分发开源参与同类竞品，如有想法可联系团队xiaonuobase@qq.com商议合作。
 *	6.若您的项目无法满足以上几点，需要更多功能代码，获取Snowy商业授权许可，请在官网购买授权，地址为 https://www.xiaonuo.vip
 */
/**
 * @Descripttion: 工具集
 * @version: 1.1
 * @LastEditors: yubaoshan
 * @LastEditTime: 2022年4月19日10:58:41
 */
const tool = {}

// localStorage
tool.data = {
	set(table, settings) {
		const _set = JSON.stringify(settings)
		const SNOWYSTRING = table.slice(0, 6) === 'SNOWY_' && table !== 'SNOWY_SYS_BASE_CONFIG'
		if (SNOWYSTRING) {
			let localSetting = JSON.parse(localStorage.getItem('SNOWY_SETTING')) || {}
			let newSetting = {}
			newSetting[table] = _set
			return localStorage.setItem('SNOWY_SETTING', JSON.stringify(Object.assign(localSetting, newSetting)))
		} else return localStorage.setItem(table, _set)
	},
	get(table) {
		const SNOWYSTRING = table.slice(0, 6) === 'SNOWY_' && table !== 'SNOWY_SYS_BASE_CONFIG'
		const SNOWY_SETTING = JSON.parse(localStorage.getItem('SNOWY_SETTING')) || {}
		let data = SNOWYSTRING ? SNOWY_SETTING[table] : localStorage.getItem(table)
		try {
			data = JSON.parse(data)
		} catch (err) {
			return null
		}
		return data
	},
	remove(table) {
		return localStorage.removeItem(table)
	},

	clear() {
		return localStorage.clear()
	}
}

// sessionStorage
tool.session = {
	set(table, settings) {
		const _set = JSON.stringify(settings)
		return sessionStorage.setItem(table, _set)
	},
	get(table) {
		let data = sessionStorage.getItem(table)
		try {
			data = JSON.parse(data)
		} catch (err) {
			return null
		}
		return data
	},
	remove(table) {
		return sessionStorage.removeItem(table)
	},
	clear() {
		return sessionStorage.clear()
	}
}

// 千分符
tool.groupSeparator = (num) => {
	num = `${num}`
	if (!num.includes('.')) num += '.'

	return num
		.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
			return `${$1},`
		})
		.replace(/\.$/, '')
}

// 获取所有字典数组
tool.dictDataAll = () => {
	return tool.data.get('DICT_TYPE_TREE_DATA')
}

// 字典翻译方法，界面插槽使用方法 {{ $TOOL.dictType('sex', record.sex) }}
tool.dictTypeData = (dictValue, value) => {
	const dictTypeTree = tool.dictDataAll()
	if (!dictTypeTree) {
		return '需重新登录'
	}
	const tree = dictTypeTree.find((item) => item.dictValue === dictValue)
	if (!tree) {
		return '-'
	}
	const children = tree.children
	const dict = children.find((item) => item.dictValue === value)
	return dict ? dict.dictLabel : '-'
}

// 获取某个code下字典的列表，多用于字典下拉框
tool.dictTypeList = (dictValue) => {
	const dictTypeTree = tool.dictDataAll()
	if (!dictTypeTree) {
		return []
	}
	const tree = dictTypeTree.find((item) => item.dictValue === dictValue)
	if (tree && tree.children) {
		return tree.children
	}
	return []
}

// 获取某个code下字典的列表，基于dictTypeList 改进，保留老的，逐步替换
tool.dictList = (dictValue) => {
	const dictTypeTree = tool.dictDataAll()
	if (!dictTypeTree) {
		return []
	}
	const tree = dictTypeTree.find((item) => item.dictValue === dictValue)
	if (tree) {
		return tree.children.map((item) => {
			return {
				value: item['dictValue'],
				label: item['name']
			}
		})
	}
	return []
}
tool.dictListName = (valueList, dictType) => {
	var list = tool.dictList(dictType)
	var name = ""
	if (valueList) {
		for (var i in valueList) {
			for (var j in list) {
				var item = list[j]
				if (item.value == valueList[i]) {
					if (i == 0) {
						name = item.label
					} else {
						name += "，" + item.label
					}
				}
			}
		}
	}
	return name
}

// 树形翻译 需要指定最顶级的 parentValue  和当级的value
tool.translateTree = (parentValue, value) => {
	const tree = tool.dictDataAll().find((item) => item.dictValue === parentValue)
	const targetNode = findNodeByValue(tree, value)
	return targetNode ? targetNode.dictLabel : ''
}
const findNodeByValue = (node, value) => {
	if (node.dictValue === value) {
		return node
	}
	if (node.children) {
		for (let i = 0; i < node.children.length; i++) {
			const result = findNodeByValue(node.children[i], value)
			if (result) {
				return result
			}
		}
	}
	return null
}

// 生成UUID
tool.snowyUuid = () => {
	let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
		let r = (Math.random() * 16) | 0,
			v = c === 'x' ? r : (r & 0x3) | 0x8
		return v.toString(16)
	})
	// 首字符转换成字母
	return 'xn' + uuid.slice(2)
}
tool.amountToChinese = (val) => {
	if (!val && val !== 0) return '';
	// 汉字的数字
	const cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
	// 基本单位
	const cnIntRadice = ['', '拾', '佰', '仟'];
	// 对应整数部分扩展单位
	const cnIntUnits = ['', '万', '亿', '兆'];
	// 对应小数部分单位
	const cnDecUnits = ['角', '分', '毫', '厘'];
	// 整数金额时后面跟的字符
	const cnInteger = '整';
	// 整型完以后的单位
	const cnIntLast = '元';
	// 最大处理的数字
	const maxNum = 999999999999999.9999;
	// 金额整数部分
	let integerNum;
	// 金额小数部分
	let decimalNum;
	// 输出的中文金额字符串
	let chineseStr = '';
	// 分离金额后用的数组，预定义
	let parts;

	val = parseFloat(val);
	if (isNaN(val)) return ''; // 处理NaN情况
	if (val >= maxNum) return '超出最大处理数字';
	if (val === 0) return cnNums[0] + cnIntLast + cnInteger;
	if (val < 0) val = -val; // 处理负数，可根据需求调整前缀

	val = val.toString();
	if (val.indexOf('.') === -1) {
		integerNum = val;
		decimalNum = '';
	} else {
		parts = val.split('.');
		integerNum = parts[0];
		decimalNum = parts[1].substr(0, 4); // 最多保留4位小数
	}

	// 获取整型部分转换
	if (parseInt(integerNum, 10) > 0) {
		let zeroCount = 0;
		const IntLen = integerNum.length;
		for (let i = 0; i < IntLen; i++) {
			const n = integerNum.substr(i, 1);
			const p = IntLen - i - 1;
			const q = Math.floor(p / 4);
			const m = p % 4;
			if (n === '0') {
				zeroCount++;
			} else {
				if (zeroCount > 0) {
					chineseStr += cnNums[0];
				}
				zeroCount = 0;
				chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
			}
			if (m === 0 && zeroCount < 4) {
				chineseStr += cnIntUnits[q];
			}
		}
		chineseStr += cnIntLast;
	}

	// 小数部分
	if (decimalNum !== '') {
		const decLen = decimalNum.length;
		for (let i = 0; i < decLen; i++) {
			const n = decimalNum.substr(i, 1);
			if (n !== '0') {
				chineseStr += cnNums[Number(n)] + cnDecUnits[i];
			}
		}
	}

	// 处理结果为空或没有小数部分的情况
	if (chineseStr === '') {
		chineseStr = cnNums[0] + cnIntLast + cnInteger;
	} else if (decimalNum === '') {
		chineseStr += cnInteger;
	}

	// 一些常见的正则替换优化输出（可选，根据实际情况调整）
	chineseStr = chineseStr
		.replace(/零拾|零佰|零仟/g, '零')
		.replace(/零+/g, '零')
		.replace(/零元/g, '元')
		.replace(/零角零分/, '整')
		.replace(/零分/, '')
		.replace(/零角/, '')
		.replace(/元$/, '元整'); // 如果整数后没有小数，且以元结尾，加上整

	return chineseStr;
}



tool.filterMaterial = (list, type) => {
	var resultList = []
	if (list && list.length > 0) {
		for (var i in list) {
			var item = list[i]
			if (item.fileList) {

			} else {
				item.fileList = []
			}

			if (type == "Incomeing") {
				if (item.materialCategory !== 'account_material' && item.materialCategory !== 'follow_up_material') {
					if (item.materialCategory == 'other_material') {
						if (item.materialNameType === 'QTZL'){
							resultList.push(item)
						}
					} else {
						resultList.push(item)
					}

				}
			} else if (type == "ZHCSPZ") {
				if (item.materialCategory === 'account_material' && item.materialNameType === 'ZHCSPZ') {
					resultList.push(item)
				}
			} else if (type == "CDD") {
				if (item.materialCategory === 'house_material' && item.materialNameType === 'CDD') {
					resultList.push(item)
				}
			} else if (type == "disbursement") {
				if (item.materialCategory === 'house_material') {
					if (item.materialNameType === 'FCZ' || item.materialNameType === 'CDD') {
						resultList.push(item)
					}
				}
				if (item.materialCategory === 'account_material') {
					if (item.materialNameType === 'ZHCSPZ') {
						resultList.push(item)
					}
				}
				if (item.materialCategory === 'other_material') {
					resultList.push(item)
				}
			} else if (type == "redemption_registration") {
				if (item.materialCategory === 'follow_up_material' && item.materialNameType === 'KKPZ') {
					resultList.push(item)
				}
			} else if (type == "follow_up_zxdypz") {
				if (item.materialCategory === 'follow_up_material' && item.materialNameType === 'ZXDYPZ') {
					resultList.push(item)
				}
			}  else if (type == "follow_up_ghpz") {
				if (item.materialCategory === 'follow_up_material' && item.materialNameType === 'GHPZ') {
					resultList.push(item)
				}
			} else if (type == "follow_up_dypz") {
				if (item.materialCategory === 'follow_up_material' && item.materialNameType === 'DYPZ') {
					resultList.push(item)
				}
			} else if (type == "collection") {
				if (item.materialCategory === 'other_material') {
					if (item.materialNameType === 'SFPZ' || item.materialNameType === 'HKPZ' || item.materialNameType === 'QTZL') {
						resultList.push(item)
					}

				}
			}else if (type == "face_interview") {
				if (item.materialCategory === 'order_contract') {
					resultList.push(item)
				}
			}
			else {
				resultList.push(item)
			}
		}
	}

	return resultList
}

tool.getFileMimeType = (filename) => {
	if (filename) {
		const parts = filename.split('.');
		return parts.length > 1 ? parts.pop().toLowerCase() : '';
	} else {
		return ""
	}
}
export default tool
